import * as React from "react";
const SvgVickyBohoInstagram = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-ed9ab4a6-744b-4f62-bca9-e57ecda656dc", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 89.23 89.23", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 44.62, cy: 44.62, r: 18.75, style: {
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
} }), /* @__PURE__ */ React.createElement("rect", { x: 1.5, y: 1.5, width: 86.23, height: 86.23, rx: 22.5, ry: 22.5, style: {
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
} }), /* @__PURE__ */ React.createElement("circle", { cx: 68.99, cy: 20.25, r: 3.75 }));
export default SvgVickyBohoInstagram;
